require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-distruptingdigitalbanking.json") })
        }
      }, "path---articles-distruptingdigitalbanking");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-distruptingdigitalbanking!./.cache/json/articles-distruptingdigitalbanking.json
// module id = 1578
// module chunks = 231608221292675